<template>
  <div class="s-clock">
    <s-clock-total 
      ref="clockTotal"
      :markedId = "markedId"
      :clockId="clockId"
      @hide="()=>{$emit('hide')}" 
      @clock="(e)=>{$emit('clock',e);}" 
      @update="getlist"></s-clock-total>
    <div class="clock-checked " ref="clockBox" >
      <div class="srollbox">
        <h3>已探索{{lockCount}}个打卡地点</h3>
        <div class="clock-list" v-if="list && list.length>0">
          <div class="clock-item" v-for="item in list">
            <van-image :src="showpath + item.scenic_picture" fit="cover"></van-image>
            <p>{{item.scenic_name}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sClockTotal from './s-clock-total.vue'
export default {
  components: { sClockTotal },
  name: 'sClock',
  props: { markedId:String | Number, clockId:String |Number},
  data(){
    return{
       showpath:'',
       list:null,
       lockCount:0,
    }
  },
  watch:{
    markedId:{
      handler(newv,oldv){
        if(newv ){
          if(!this.clockId||newv!=this.clockId){
            // console.log("markedId",newv);
            this.getlist(newv)
          } 
        }
      },immediate:true
    },
    clockId:{
      handler(newv,oldv){
        if(newv && newv != oldv){
          this.getlist(newv)
        }
      },immediate:true
    }
  },
  mounted() {
    if(this.markedId || this.clockId){
      // console.log("进入有mark");
      // this.getlist(this.markedId)
    }else{
      // console.log("进入没有mark");
      this.getlist()
    }
    
  },
methods:{
  getlist(markedId){
    this.$api.clockApi.getList({
      type:1,
    }).then(res=>{
      if(res && res.data){
        this.showpath = res.showpath
        this.list = res.data
        this.lockCount = res.data.length
        if(markedId){
          let obj = this.list.find(t=>{return t.scenic_id == markedId})
          // console.log("重新请求8的啊，",obj,markedId)
            if(obj){
              let nowPos = {
                name:obj.scenic_name,
                id:obj.scenic_id,
                cover_img:obj.scenic_picture
              }
              this.$refs.clockTotal.posNow(nowPos)
            }else{
              // console.log("没有的");
              this.$refs.clockTotal.posNow(markedId)
            }
        }

      }
    })
  },

},
}
</script>
<style scoped lang="scss">
  .s-clock{
    // background: #fff url(../../assets/images/bg2.png) center top no-repeat;
    background: linear-gradient(180deg, #A9F1DF 0%, #ffffff 40%);
    background-size: 105%;
    padding: 20rem 0 40rem;
    max-width: var(--maxWidth);
    margin: 0 auto;
    border-radius: 20rem 20rem 0 0;
  }
  .clock-checked{
    background: #fff;
    box-shadow: 0 4px 10px rgba($color: #000000, $alpha: 0.12);
    box-sizing: border-box;
    padding: 15rem 15rem 10rem;
    margin:0 15rem;
    border-radius: 15rem;
    min-height: 100rem;
    padding-right: 0;
    overflow: hidden;
    // overflow-y: auto;
    // max-height: 200rem;
    h3{
      font-size: 14rem;
      margin-bottom: 21rem;
      font-weight: normal;
    }
    .srollbox{
      overflow: hidden;
      overflow-y: auto;
      // max-height: 200rem;
      max-height: 120rem;
      box-sizing: border-box;
      padding-right: 15rem;
    }

  }
  .clock-list{
    display: flex;
    flex-wrap: wrap;
    .clock-item{
      width: 50%;
      display: flex;
      align-items: center;
      margin-bottom: 12rem;
      .van-image{
        width: 31rem;
        height: 31rem;
        margin-right: 9rem;
        flex-shrink: 0;
      }
      p{
        white-space: nowrap;
        max-width: calc(100% - 31rem - 10rem);
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

</style>